import wx from 'weixin-js-sdk';
import { decorator, before } from 'ym-reporter-vue';
import { createOrder } from '@/services/order';
import { commonLog } from '@/services/app';
import {
 locationHref, isMiniWebView, setToLocalStorage, isWeiXinBrowser,
} from '@/utils';

const createOrderMixin = {
  methods: {
    mixinCreateOrder(res) {
      return new Promise(async (resolve, reject) => {
        const { fullPath } = this.$route;
        const {
          targetId,
          targetType,
          targetCount,
          couponIds,
          discountIds,
          addressId,
          message = '',
          shouldPay,
          shouldPayPoint = 0,
          payActionSource,
        } = res;
        const createOrderParams = {
          targetId,
          targetType,
          redirectTo: fullPath,
          targetCount,
          couponIds,
          discountIds,
          addressId,
          message,
          shouldPay,
          shouldPayPoint,
          payActionSource,
        };

        try {
          const data = await createOrder(createOrderParams);
          await this.mixinHandleOrderAction(data, payActionSource);
          return resolve();
        } catch (e) {
          this.showPayPopup = false;
          commonLog('createOrderError', JSON.stringify({
            req: createOrderParams,
            res: e,
          }));
          return reject(e);
        }
      });
    },
    mixinHandleOrderAction(data, payActionSource) {
      const {
        action, pay, sn,
      } = data;
      return new Promise((resolve, reject) => {
        switch (action) {
          case 'pay': {
            // 非0元要给钱

            // 是否在小程序 webview
            if (isMiniWebView()) {
              wx.miniProgram.navigateTo({ url: `/pages/pay/index?sn=${data.sn}` });
              return resolve();
            }
            if (isWeiXinBrowser() && payActionSource === 'payCenter') {
              setToLocalStorage('pay-center-back', true);
            }
            const { weChatUrl } = pay;
            locationHref(weChatUrl, 'replace');
            this.showPayPopup = false;
            return resolve();
          }
          case 'notify': {
            // 0元，且已成功
            this.handleRecordPaySuccess(sn, payActionSource);
            return resolve();
          }
          default: {
            commonLog('createOrderActionError', action);
            return reject(new Error(`createOrder error with action: ${action}`));
          }
        }
      });
    },
    @decorator(before(function (sn, payActionSource) {
      let recordName;
      switch (payActionSource) {
        case 'popup': {
          recordName = 'PAY_POPUP_PAY_SUCCESS';
          break;
        }
        case 'seckill': {
          recordName = 'PAY_SECKILL_PAY_SUCCESS';
          break;
        }
        default: {
          recordName = 'PAY_FORM_PAY_SUCCESS';
        }
      }
      this.$reporter.report(recordName, { sn });
    }))
    handleRecordPaySuccess(sn, payActionSource) {
      const route = { name: 'PayWaiting', query: { sn, payActionSource } };
      this.$router.replace(route);
      this.showPayPopup = false;
    },
  },
};

export default createOrderMixin;
